import configureApiRestService from "./apiService";
import CookiesKeys, { cookieStorage } from "./cookies";

export const getToken = (): string | null => {
  return localStorage.getItem(CookiesKeys.TokenKey);
};

export const login = (token: string) => {
  localStorage.setItem(CookiesKeys.TokenKey, token);
};

export const logout = () => {
  localStorage.removeItem(CookiesKeys.TokenKey);
  removeloginCookie();
  window.location.reload();
};

export const getTokenCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.TokenKey);
};

export const loginCookie = (token: string) => {
  cookieStorage.setItem(CookiesKeys.TokenKey, token);
};

export const setValidationMainModules = (validate: string) => {
  cookieStorage.setItem(CookiesKeys.MainModules, validate);
};
export const getValidationMainModules = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.MainModules);
};

export const tenantCookie = (id: string,) => {
  cookieStorage.setItem(CookiesKeys.Tenant, id);
};
export const getIdCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Id);
};
export const getTenantCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Tenant);
};
export const getUserCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.User);
};
export const removeloginCookie = () => {
  cookieStorage.removeItem(CookiesKeys.TokenKey);
};


export const modulesCookie = (id: string,) => {
  cookieStorage.setItem(CookiesKeys.Modules, id);
};
export const rolCookie = (id: string,) => {
  cookieStorage.setItem(CookiesKeys.Rol, id);
};
export const getModulesCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Modules);
};
export const getRolCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Rol);
};


// ===== Service =====
export const setSelectedServiceCookie = (service: object) => {
  cookieStorage.setItem(CookiesKeys.SelectedService, JSON.stringify(service));
};
export const getSelectedServiceCookie = () => {
  const data = cookieStorage.getItem(CookiesKeys.SelectedService);
  return data ? JSON.parse(data) : null;
};
export const removeSelectedServiceCookie = () => {
  cookieStorage.removeItem(CookiesKeys.SelectedService);
};

// ===== Floor =====
export const setSelectedFloorCookie = (floor: object) => {
  cookieStorage.setItem(CookiesKeys.SelectedFloor, JSON.stringify(floor));
};
export const getSelectedFloorCookie = () => {
  const data = cookieStorage.getItem(CookiesKeys.SelectedFloor);
  return data ? JSON.parse(data) : null;
};
export const removeSelectedFloorCookie = () => {
  cookieStorage.removeItem(CookiesKeys.SelectedFloor);
};

// ===== Center =====
export const setSelectedCenterCookie = (center: object) => {
  cookieStorage.setItem(CookiesKeys.SelectedCenter, JSON.stringify(center));
};
export const setSelectedCounterCookie = (counter: object) => {
  cookieStorage.setItem(CookiesKeys.SelectedCounter, JSON.stringify(counter));
};
export const getSelectedCenterCookie = () => {
  const data = cookieStorage.getItem(CookiesKeys.SelectedCenter);
  return data ? JSON.parse(data) : null;
};
export const getSelectedCounterCookie = () => {
  const data = cookieStorage.getItem(CookiesKeys.SelectedCounter);
  return data ? JSON.parse(data) : null;
};

export const removeSelectedCounterCookie = () => {
  cookieStorage.removeItem(CookiesKeys.SelectedCounter);
};

export const removeSelectedCenterCookie = () => {
  cookieStorage.removeItem(CookiesKeys.SelectedCenter);
};

export const clearSelectionCookies = () => {
  cookieStorage.removeItem(CookiesKeys.SelectedService);
  cookieStorage.removeItem(CookiesKeys.SelectedFloor);
  cookieStorage.removeItem(CookiesKeys.SelectedCenter);
  cookieStorage.removeItem(CookiesKeys.SelectedCounter);
};

export const removeAllCookies = () => {
  Object.values(CookiesKeys).forEach((key) => {
    cookieStorage.removeItem(key);
  });

  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  });
 //configureApiRestService()
};


export const isAuthenticated = () => {  
  return document.cookie.split(';').some(c => c.trim().startsWith('tokenKey='));
};
export const getRolFromToken = (): string | null => {
  const token = getTokenCookie();
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload["rol"] || null; 
  } catch {
    return null;
  }
};

export const isAdmin = (): boolean => {
  return getRolFromToken() === 'ADMIN';
};

